/** Ciphertext from mongoose-field-encryption (hex salt + ':' + payload). */
export function isEncryptedPreviewValue(value) {
  if (typeof value !== "string" || !value.includes(":")) return false;
  const [prefix] = value.split(":");
  return prefix.length >= 16 && /^[0-9a-f]+$/i.test(prefix);
}

/** Inbox list preview line — never show raw ciphertext. */
export function getInboxListPreview(item) {
  if (!item) return "";
  const body = String(item.message || "").trim();
  if (body && !isEncryptedPreviewValue(body)) return body;
  const caption = String(item.mediatxt || "").trim();
  if (caption && !isEncryptedPreviewValue(caption)) return caption;
  if (item.isMMS || (Array.isArray(item.media) && item.media.length > 0)) return "[Media]";
  return "";
}

/**
 * Chat bubble body — prefer mediatxt, never show ciphertext.
 * Media-only messages (no caption / text) return "" so the bubble shows just the
 * media; the "[Media]" placeholder is only for the inbox list preview.
 */
export function getGatewayMessageBody(msg) {
  if (!msg) return "";
  const caption = String(msg.mediatxt || "").trim();
  if (caption && !isEncryptedPreviewValue(caption)) return caption;
  const body = String(msg.message || "").trim();
  if (body && !isEncryptedPreviewValue(body)) return body;
  return "";
}
